import type { TableScalarValue } from '../model';
import { DataExportError, type TabularDataExport } from './model';

export const CSV_UTF8_BOM = '\uFEFF';

export function protectCsvString(value: string): string {
  return /^[=+\-@]/.test(value) ? `'${value}` : value;
}

function csvCell(value: TableScalarValue): TableScalarValue {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return protectCsvString(value);
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  throw new DataExportError('The CSV contains a value that cannot be exported safely.');
}

export async function serializeCsvExport(exportData: TabularDataExport): Promise<string> {
  const { default: Papa } = await import('papaparse');
  const rows = exportData.rows.map((row) => row.map((value) => csvCell(value ?? null)));
  return (
    CSV_UTF8_BOM +
    Papa.unparse(
      {
        fields: exportData.fields.map((field) => protectCsvString(field.outputField)),
        data: rows,
      },
      { delimiter: ',', newline: '\r\n' },
    )
  );
}
